import * as http from "./base";

const prefix = "/templates-";

export async function fetchTemplatesList({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`${prefix}list/?${qs}`);
}

export async function createTemplate(data) {
  return await http.post(`${prefix}create`, data, { newErrorFormat: true });
}

export async function fetchTemplateById(id) {
  return await http.get(`${prefix}retrieve/${id}`);
}

export async function renderTemplate(id) {
  return await http.get(`${prefix}/${id}/render`);
}

export async function deleteTemplate(id) {
  return await http.del(`${prefix}delete/${id}`);
}

export async function saveTemplate(id, data) {
  return await http.patch(`${prefix}update/${id}`, data);
}

export async function triggerTestPreview(data) {
  return await http.post(`${prefix}preview`, data);
}

export async function fetchStaticTemplate(
  template,
  side,
  account_id,
  schema = "builder"
) {
  const isDev = process.env.NODE_ENV === "development";
  const rendererApi = isDev
    ? "https://internal.next.inkit.io/renderer"
    : "/renderer";

  return await http.post(
    rendererApi,
    {
      template,
      side,
      schema,
      account_id
    },
    {
      rawUrl: isDev
    }
  );
}
